if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.touchStartX = null;
        this.touchStartY = null;
        this.mediaItems = [];

        this.dialog = this.querySelector('.product-media-modal__dialog');
        this.content = this.querySelector('.product-media-modal__content');
        this.prevButton = this.querySelector('[data-wh169-media-prev]');
        this.nextButton = this.querySelector('[data-wh169-media-next]');
        this.currentCounter = this.querySelector('[data-wh169-media-current]');
        this.totalCounter = this.querySelector('[data-wh169-media-total]');

        // Dawn's base media modal closes on pointer-up. Inside this upgraded
        // gallery we keep the modal open while the customer browses media.
        this.dialog?.addEventListener('pointerup', (event) => event.stopPropagation());

        this.prevButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.goTo(this.currentIndex - 1);
        });

        this.nextButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.goTo(this.currentIndex + 1);
        });

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.currentIndex - 1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.currentIndex + 1);
          }
        });

        this.content?.addEventListener(
          'touchstart',
          (event) => {
            if (event.touches.length !== 1) return;
            this.touchStartX = event.touches[0].clientX;
            this.touchStartY = event.touches[0].clientY;
          },
          { passive: true }
        );

        this.content?.addEventListener(
          'touchend',
          (event) => {
            if (this.touchStartX === null || !event.changedTouches.length) return;
            const dx = event.changedTouches[0].clientX - this.touchStartX;
            const dy = event.changedTouches[0].clientY - this.touchStartY;
            this.touchStartX = null;
            this.touchStartY = null;
            if (Math.abs(dx) < 44 || Math.abs(dx) <= Math.abs(dy)) return;
            this.goTo(dx < 0 ? this.currentIndex + 1 : this.currentIndex - 1);
          },
          { passive: true }
        );
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.refreshMediaItems();
        const requestedId = opener?.getAttribute('data-media-id');
        const requestedIndex = this.mediaItems.findIndex((item) => item.getAttribute('data-media-id') === requestedId);
        this.goTo(requestedIndex >= 0 ? requestedIndex : 0, false);
      }

      refreshMediaItems() {
        this.mediaItems = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
        if (this.totalCounter) this.totalCounter.textContent = String(this.mediaItems.length);
      }

      goTo(index, announce = true) {
        if (!this.mediaItems.length) this.refreshMediaItems();
        const total = this.mediaItems.length;
        if (!total) return;

        // Infinite wrap-around is more convenient in a fullscreen gallery.
        this.currentIndex = ((index % total) + total) % total;
        window.pauseAllMedia?.();

        this.mediaItems.forEach((item, itemIndex) => {
          const active = itemIndex === this.currentIndex;
          item.classList.toggle('active', active);
          item.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        const activeMedia = this.mediaItems[this.currentIndex];
        if (activeMedia?.nodeName === 'DEFERRED-MEDIA') activeMedia.loadContent?.();
        if (activeMedia?.matches('.product-media-modal__model')) {
          activeMedia.querySelector('deferred-media')?.loadContent?.();
        }

        if (this.currentCounter) this.currentCounter.textContent = String(this.currentIndex + 1);
        if (announce && this.currentCounter) {
          this.currentCounter.parentElement?.setAttribute(
            'aria-label',
            `Product image ${this.currentIndex + 1} of ${total}`
          );
        }
      }

      // Kept for compatibility with code that calls the old Dawn method.
      showActiveMedia() {
        this.refreshMediaItems();
        const requestedId = this.openedBy?.getAttribute('data-media-id');
        const requestedIndex = this.mediaItems.findIndex((item) => item.getAttribute('data-media-id') === requestedId);
        this.goTo(requestedIndex >= 0 ? requestedIndex : 0, false);
      }
    }
  );
}
